export const assertNever = input => {
  throw new Error(`should be never - ${input}`);
};
//# sourceMappingURL=assert-never.js.map